import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SearchBoxModalComponent } from '@b2b/components/cms/sections/cx-header-section/components/search-box/search-box-modal/search-box-modal.component';
import { SearchBoxService } from '@b2b/components/cms/sections/cx-header-section/components/search-box/search-box.service';

@Component({
  selector: 'search-box',
  imports: [CommonModule, SearchBoxModalComponent],
  templateUrl: './search-box.component.html',
  styleUrl: './search-box.component.scss',
})
export class SearchBoxComponent {
  constructor(private searchBoxService: SearchBoxService) {}

  open() {
    this.searchBoxService.toggleStatus(true);
  }
}
